import styled from '@emotion/styled';

const Cell = styled.button`
  position: relative;
  width: 100%;
  height: 22.4vw;
  border: none;
  border-radius: 1.6vw;
  background: linear-gradient(180deg, #4f6591 0%, #1b2f57 100%);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: 6.1vw;
  padding-right: 14.9vw;
  @media (orientation: landscape) {
    width: 28vw;
    height: 23.9vw;
    border-radius: 1.6vw;
    flex-direction: column;
    padding: unset;
    padding-top: 0.9vw;
    padding-bottom: 2.7vw;
  }
  &:focus {
    background: linear-gradient(180deg, #4f6591 0%, #1b2f57 50%);
  }
`;

const CellIcon = styled.img`
  width: 21.1vw;
  height: 21.1vw;
  @media (orientation: landscape) {
    width: 15.6vw;
    height: 15.6vw;
  }
`;

const CellTitle = styled.div`
  font-size: 5.6vw;
  line-height: 7.8vw;
  color: #ffffff;
  @media (orientation: landscape) {
    font-size: 2.8vw;
    line-height: 4vw;
  }
`;

export { Cell, CellIcon, CellTitle };
